import { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FilterOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/FilterOutlined';
import ClearFilters from '../clear-filters/ClearFilters';
import styles from './FacetsHeader.module.scss';

export const FacetsHeader = ({
  baseFacetId = '',
  showClearFiltersSticky = false,
  onClearAllClick,
}) => {
  return (
    <Fragment>
      <div
        data-testid="filter-header-container"
        className={classnames(styles.facets__headerContainer)}
      >
        <div className={classnames(styles.facets__iconHeader)}>
          <FilterOutlined title="Apply filters" size="medium" />
          <h2 className={classnames(styles.facets__header)}>Filters</h2>
        </div>
        <ClearFilters
          baseFacetId={baseFacetId}
          isInStickyLHN
          onClearAllClick={onClearAllClick}
          query={{ page: undefined }}
          show={showClearFiltersSticky}
          showCount
        />
      </div>
    </Fragment>
  );
};

FacetsHeader.propTypes = {
  baseFacetId: PropTypes.string,
  showClearFiltersSticky: PropTypes.bool,
  onClearAllClick: PropTypes.func,
};

export default memo(FacetsHeader);
